import style from "./style.module.scss";

type PropsType = {
  label: string;
  value: string;
};

export const TitleBadge = ({ label, value }: PropsType) => {
  return (
    <div className={style.title_badge__title_wrapper}>
      <span className={style.title_badge__title}>{label} : </span>
      <span className={style.title_badge__title_value}> {value} </span>
    </div>
  );
};
